export var EVillageRequestType = /*#__PURE__*/function (EVillageRequestType) {
  EVillageRequestType["AddingVillage"] = "addingVillage";
  EVillageRequestType["EditingVillage"] = "editingVillage";
  return EVillageRequestType;
}({});